const BASE_URL = "https://www.cyberpunk.pk";

export const absoluteUrl = (path = "/") => {
  if (!path) return BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildBreadcrumbSchema = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: absoluteUrl(item.path),
  })),
});

export const buildBlogPostingSchema = (post, category) => {
  if (!post) return null;
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    mainEntityOfPage: absoluteUrl(`/blog/${post.slug}`),
    datePublished: post.dateISO,
    dateModified: post.updatedISO || post.dateISO,
    author: {
      "@type": "Organization",
      name: "Cyberpunk Editorial Team",
      url: absoluteUrl("/editorial-policy"),
    },
    publisher: {
      "@type": "Organization",
      name: "Cyberpunk",
      logo: {
        "@type": "ImageObject",
        url: absoluteUrl("/logo192.png"),
      },
    },
    articleSection: category?.name || post.categorySlug,
    keywords: (post.keywords || []).join(", "),
    inLanguage: "en-PK",
    isAccessibleForFree: true,
  };
};

export const buildFaqSchema = (faqs = []) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (faqs || []).map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});

export const buildSoftwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": absoluteUrl("/analysis#software"),
  name: "CDR Analyzer Tool",
  applicationCategory: "SecurityApplication",
  applicationSubCategory: "Call Detail Record analysis",
  operatingSystem: "Web",
  url: absoluteUrl("/analysis"),
  image: absoluteUrl("/logo512.png"),
  description:
    "Free browser-based Call Detail Record analysis for authorized Pakistan telecom Excel and CSV files, with contact, location, IMEI, timeline, and network summaries.",
  featureList: [
    "Excel and CSV CDR validation",
    "Contact and call activity analysis",
    "Location and cell-site summaries",
    "IMEI and device analysis",
    "Network graph visualization",
  ],
  isAccessibleForFree: true,
  keywords: "cdr call data record pakistan online free, cdr data online check, cdr analysis online free, cdr analysis online, cdr data online, cdr analyzer, cdr analysis",
  publisher: {
    "@type": "Organization",
    name: "Cyberpunk",
  },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "PKR",
  },
});

export const buildWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": absoluteUrl("/#website"),
  name: "Cyberpunk",
  url: absoluteUrl("/"),
  description: "Browser-based CDR analysis tools and practical telecom investigation guides for authorized users.",
  publisher: { "@id": absoluteUrl("/#organization") },
  inLanguage: "en-PK",
});

export const buildWebPageSchema = ({ name, description, path = "/analysis" }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": absoluteUrl(`${path}#webpage`),
  name,
  description,
  url: absoluteUrl(path),
  isPartOf: { "@id": absoluteUrl("/#website") },
  about: { "@id": absoluteUrl("/analysis#software") },
  inLanguage: "en-PK",
});

export const buildOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": absoluteUrl("/#organization"),
  name: "Cyberpunk",
  alternateName: "Cyberpunk CDR Analyzer",
  url: BASE_URL,
  logo: absoluteUrl("/logo192.png"),
  email: "contact@cyberpunk.pk",
  description: "Cyberpunk provides browser-based CDR analysis tools and original telecom investigation guides.",
});
